import {Component, EventEmitter, Input, Output} from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatLabel, MatFormField } from "@angular/material/form-field";
import {Administration} from "@shared/objects/administration";
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';

@Component({
    selector: 'uf-select-administration',
    templateUrl: './select-administration.component.html',
    styleUrls: ['./select-administration.component.scss'],
    providers: [{
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                appearance: 'outline',
                subscriptSizing: 'dynamic'
            }
        }],
    imports: [MatLabel, MatFormField, MatSelect, MatOption]
})
export class SelectAdministrationComponent {
  @Input() administration: Administration;
  @Input() administrations: Administration[];
  @Output() administrationChange: EventEmitter<Administration> = new EventEmitter<Administration>();

  protected readonly Administration = Administration;
}
